module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "slider-next-black.0d5259c8.svg";